// src/pages/HomePage.jsx
import React from "react";
import { Link } from "react-router-dom";

// ✅ 放你的 icon 到这个路径（你也可以改名/改路径）
import GlowGateIcon from "../assets/glowgate-icon-1024.png";

const SUPPORT_EMAIL = "support@starepochlabs.com";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#070A12] text-slate-100">
      {/* Ambient background */}
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-48 left-1/2 h-[720px] w-[720px] -translate-x-1/2 rounded-full bg-blue-600/20 blur-[140px]" />
        <div className="absolute top-32 left-10 h-[460px] w-[460px] rounded-full bg-cyan-400/10 blur-[140px]" />
        <div className="absolute bottom-0 right-0 h-[640px] w-[640px] rounded-full bg-indigo-500/10 blur-[140px]" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/[0.03] via-transparent to-black/40" />
      </div>

      {/* Hero */}
      <section className="relative">
        <div className="mx-auto max-w-6xl px-6 pb-10 pt-14 md:pb-14 md:pt-20">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs text-slate-200/80">
            <span className="inline-block h-2 w-2 rounded-full bg-red-500" />
            Privacy-first networking • Security primitives • Transparent practices
          </div>

          <h1 className="mt-6 text-4xl font-semibold tracking-tight text-white md:text-5xl">
            Privacy-first networking software
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-200/75 md:text-lg">
            Build secure, reliable connectivity with engineering-first security and clear,
            transparent data practices.
          </p>

          {/* CTAs */}
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/trust"
              className="inline-flex items-center justify-center rounded-xl bg-red-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-red-500"
            >
              Trust Center
            </Link>

            <Link
              to="/support"
              className="inline-flex items-center justify-center rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white/90 transition hover:bg-white/10"
            >
              Support
            </Link>

            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white/90 transition hover:bg-white/10"
            >
              Contact
            </Link>
          </div>

          {/* ✅ GlowGate product callout (NEW) */}
          <div className="mt-10 grid gap-6 md:grid-cols-[1.2fr,0.8fr]">
            <div className="rounded-3xl border border-white/10 bg-white/5 p-8">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center rounded-full border border-white/10 bg-black/20 px-3 py-1 text-xs text-slate-200/75">
                  Product
                </span>
                <span className="inline-flex items-center rounded-full border border-white/10 bg-black/20 px-3 py-1 text-xs text-slate-200/75">
                  In development
                </span>
                <span className="inline-flex items-center rounded-full border border-white/10 bg-black/20 px-3 py-1 text-xs text-slate-200/75">
                  iOS
                </span>
              </div>

              <h2 className="mt-4 text-2xl font-semibold tracking-tight text-white md:text-3xl">
                GlowGate
              </h2>


              <p className="mt-3 text-sm leading-relaxed text-slate-200/75 md:text-base">
              GlowGate is an iOS network utility designed for secure connectivity and privacy-first
              networking. Built with responsible data practices, clear user expectations, and
              App Store-ready support standards.
              </p>


              <div className="mt-4 grid gap-3 sm:grid-cols-2">
    

                <MiniPill
                  title="Distribution"
                  desc="Planned distribution via Apple’s ecosystem (App Store)."
                />
                <MiniPill
                  title="Business model"
                  desc="Planned subscription revenue. Currently pre-launch (pre-revenue)."
                />

              </div>

              <div className="mt-5 text-xs text-slate-200/55">
              Disclosure: GlowGate is currently under development; features, timelines, and availability are subject to change.
              </div>

            </div>

            {/* Icon card */}
            <div className="rounded-3xl border border-white/10 bg-white/5 p-8">
              <div className="text-sm font-semibold text-white">App icon</div>
              <div className="mt-4 flex items-center justify-center">
                <div className="relative">
                  <div className="pointer-events-none absolute -inset-10 rounded-full bg-blue-500/20 blur-[50px]" />
                  <img
                    src={GlowGateIcon}
                    alt="GlowGate app icon"
                    className="relative h-40 w-40 rounded-[28px] border border-white/10 bg-black/20 object-cover shadow-lg md:h-44 md:w-44"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="mt-4 text-center text-sm text-slate-200/70">
                GlowGate • iOS (planned)
              </div>
            </div>
          </div>

          {/* Stats / trust cues */}
          <div className="mt-10 grid gap-4 md:grid-cols-3">
            <TrustPill title="Data minimization" desc="Collect less. Keep it explicit." />
            <TrustPill title="Secure transport" desc="Modern encryption & safe defaults." />
            <TrustPill title="Operational reliability" desc="Built for stability and supportability." />
          </div>
        </div>
      </section>

      {/* What we build */}
      <section className="relative">
        <div className="mx-auto max-w-6xl px-6 py-12 md:py-16">
          <div className="flex flex-col gap-3">
            <h2 className="text-2xl font-semibold tracking-tight text-white md:text-3xl">
              What we build
            </h2>
            <p className="max-w-2xl text-slate-200/70">
              Security and privacy primitives for modern networking applications.
              Designed for clarity, maintainability, and responsible operations.
            </p>
          </div>

          <div className="mt-8 grid gap-6 md:grid-cols-3">
            <FeatureCard
              title="Data minimization"
              desc="We design for minimal necessary data, with transparent handling and clear user expectations."
            />
            <FeatureCard
              title="Security-first engineering"
              desc="Safe defaults, clear boundaries, and practical security measures that scale with your product."
            />
            <FeatureCard
              title="Reliability & support"
              desc="Operational discipline and support readiness built into the product lifecycle."
            />
          </div>

          {/* Secondary callout */}
          <div className="mt-8 rounded-3xl border border-white/10 bg-white/5 p-8">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div>
                <h3 className="text-lg font-semibold text-white">
                  Looking for policies and support details?
                </h3>
                <p className="mt-1 text-sm text-slate-200/70">
                  Review our Trust Center, Privacy Policy, and Terms in one place.
                </p>
              </div>
              <div className="mt-4 flex flex-wrap gap-3 md:mt-0">
                <Link
                  to="/privacy"
                  className="rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white/90 transition hover:bg-white/10"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms"
                  className="rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white/90 transition hover:bg-white/10"
                >
                  Terms
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Center preview */}
      <section className="relative" id="trust">
        <div className="mx-auto max-w-6xl px-6 py-12 md:py-16">
          <div className="flex flex-col gap-3">
            <h2 className="text-2xl font-semibold tracking-tight text-white md:text-3xl">
              Trust Center
            </h2>
            <p className="max-w-2xl text-slate-200/70">
              We keep our policies readable and our support channels clear. Trust is built
              through transparency and consistent operations.
            </p>
          </div>

          <div className="mt-8 grid gap-6 md:grid-cols-2">
            <div className="rounded-3xl border border-white/10 bg-white/5 p-8">
              <h3 className="text-lg font-semibold text-white">Privacy principles</h3>
              <ul className="mt-4 space-y-3 text-sm text-slate-200/75">
                <li className="flex gap-3">
                  <span className="mt-1 inline-block h-2 w-2 rounded-full bg-red-500" />
                  Transparency by default
                </li>
                <li className="flex gap-3">
                  <span className="mt-1 inline-block h-2 w-2 rounded-full bg-red-500" />
                  Data minimization and purpose limitation
                </li>
                <li className="flex gap-3">
                  <span className="mt-1 inline-block h-2 w-2 rounded-full bg-red-500" />
                  Security-first engineering and safe defaults
                </li>
              </ul>

              <div className="mt-6">
                <Link
                  to="/trust"
                  className="inline-flex items-center justify-center rounded-xl bg-red-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-red-500"
                >
                  View Trust Center
                </Link>
              </div>
            </div>

            <div className="rounded-3xl border border-white/10 bg-white/5 p-8">
              <h3 className="text-lg font-semibold text-white">Support</h3>

              <div className="mt-4 rounded-2xl border border-white/10 bg-black/20 p-5">
                <div className="text-sm text-slate-200/70">Email</div>
                <a
                  className="mt-1 inline-block text-base font-semibold text-red-400 hover:text-red-300"
                  href={`mailto:${SUPPORT_EMAIL}`}
                >
                  {SUPPORT_EMAIL}
                </a>
                <div className="mt-2 text-sm text-slate-200/70">
                  Typical response time: 1–2 business days.
                </div>
              </div>

              <div className="mt-5 text-sm leading-relaxed text-slate-200/70">
                For policy documents, see{" "}
                <Link className="font-semibold text-red-400 hover:text-red-300" to="/privacy">
                  Privacy
                </Link>{" "}
                and{" "}
                <Link className="font-semibold text-red-400 hover:text-red-300" to="/terms">
                  Terms
                </Link>
                .
              </div>

              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/support"
                  className="rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white/90 transition hover:bg-white/10"
                >
                  Support Page
                </Link>
                <Link
                  to="/contact"
                  className="rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white/90 transition hover:bg-white/10"
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function TrustPill({ title, desc }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <div className="text-sm font-semibold text-white">{title}</div>
      <div className="mt-1 text-sm text-slate-200/70">{desc}</div>
    </div>
  );
}

function FeatureCard({ title, desc }) {
  return (
    <div className="rounded-3xl border border-white/10 bg-white/5 p-8">
      <div className="text-base font-semibold text-white">{title}</div>
      <div className="mt-3 text-sm leading-relaxed text-slate-200/70">{desc}</div>
    </div>
  );
}

function MiniPill({ title, desc }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
      <div className="text-xs font-semibold text-white/90">{title}</div>
      <div className="mt-1 text-xs leading-relaxed text-slate-200/70">{desc}</div>
    </div>
  );
}
